import { render, staticRenderFns } from "./UserConfigMobile.vue?vue&type=template&id=e7da4ffe&scoped=true&"
import script from "./UserConfigMobile.vue?vue&type=script&lang=ts&"
export * from "./UserConfigMobile.vue?vue&type=script&lang=ts&"
import style0 from "./UserConfigMobile.vue?vue&type=style&index=0&id=e7da4ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7da4ffe",
  null
  
)

export default component.exports